import {
  CampaignCodesCompressed,
  CampaignCodeGeneratorStructure,
} from '../../api/types'

export interface CampaignCodesState {
  loading: string[]
  error: string[]
  metricsList: string[]
  codes: CampaignCodesCompressed[]
  loadingStatus: boolean
  usersCodes: CampaignCodesCompressed[]
  generatedStructure: CampaignCodeGeneratorStructure | null
  batchCodesTotal: number
  batchUsersCodes: any[]
  ftpDetails: FTPDetails
  recentlyValidatedUrls: any
}

export const initialState = {
  loading: [],
  error: [],
  recentlyValidatedUrls: {},
  metricsList: [],
  codes: [],
  loadingStatus: false,
  usersCodes: [],
  generatedStructure: null,
  batchUsersCodes: [],
  batchCodesTotal: 0,
  ftpDetails: {
    adobeFTPHost: '',
    adobeFTPLogin: '',
    adobeFTPPassword: '',
    relationID: '',
    reportID: '',
  },
}

export const keys = ['generatedStructure']

export const campaignCodes = (
  state: CampaignCodesState = initialState,
  action: ReduxAction,
): CampaignCodesState => {
  switch (action.type) {
    case 'GET_FTP_DETAILS': {
      const {
        adobeFTPHost,
        adobeFTPLogin,
        relationID,
        reportID,
      } = action.payload

      const ftpDetails = {
        adobeFTPHost,
        adobeFTPLogin,
        adobeFTPPassword: '',
        relationID,
        reportID,
      }
      return {
        ...state,
        ftpDetails,
      }
    }
    default:
      return state
  }
}
